import {
  FETCH_NOTIFICATIONS,
  FETCH_NOTIFICATIONS_SUCCESS,
  FETCH_NOTIFICATIONS_FAILED,
  EDIT_NOTIFICATIONS,
  SEND_NOTIFICATION,
  SEND_NOTIFICATION_SUCCESS,
  SEND_NOTIFICATION_FAILED,
} from "../store/types";
import { RequestPushMsg } from '../other/NotificationFunctions';
import { firebase } from '../config/configureFirebase';
import { onValue, set, push, remove, off } from "firebase/database";
import store from '../store/store';

const loadUserNotificationsViaRest = async (uid, dispatch) => {
  try {
    const { getValidAuthToken } = require("./authactions");
    let token = await getValidAuthToken();
    if (!token) return false;
    const baseUrl = (firebase.config?.databaseURL || "https://drive2go-c806b-default-rtdb.europe-west1.firebasedatabase.app").replace(/\/$/, '');
    let rtdbUrl = `${baseUrl}/userNotifications/${uid}.json?auth=${token}`;
    let res = await fetch(rtdbUrl);
    if (res.status === 401) {
      token = await getValidAuthToken(true);
      if (token) {
        rtdbUrl = `${baseUrl}/userNotifications/${uid}.json?auth=${token}`;
        res = await fetch(rtdbUrl);
      }
    }
    if (res.ok) {
      const data = await res.json();
      if (data && typeof data === 'object') {
        const arr = Object.keys(data).map(i => {
          data[i].id = i;
          return data[i];
        });
        arr.sort((a, b) => Number(b.dated || b.createdAt || 0) - Number(a.dated || a.createdAt || 0));
        dispatch({
          type: FETCH_NOTIFICATIONS_SUCCESS,
          payload: arr
        });
        return true;
      } else {
        dispatch({
          type: FETCH_NOTIFICATIONS_SUCCESS,
          payload: []
        });
        return true;
      }
    }
  } catch (e) {
    console.warn('[NOTIFICATIONS] REST fetch error:', e?.message);
  }
  return false;
};

export const fetchUserNotifications = () => (dispatch, getState) => {

  const {
    auth,
    userNotificationsRef
  } = firebase;

  dispatch({
    type: FETCH_NOTIFICATIONS,
    payload: null
  });

  const state = typeof getState === 'function' ? getState() : (store ? store.getState() : {});
  const uid = auth?.currentUser?.uid || state?.auth?.profile?.uid || state?.auth?.info?.profile?.uid || state?.auth?.profile?.id || (typeof store !== 'undefined' && store?.getState()?.auth?.profile?.uid);
  if (!uid || !userNotificationsRef) {
    dispatch({
      type: FETCH_NOTIFICATIONS_SUCCESS,
      payload: []
    });
    return;
  }

  // Immediate REST load for quick availability without WebSocket delay
  loadUserNotificationsViaRest(uid, dispatch);

  try {
    if (typeof off === 'function') {
      try { off(userNotificationsRef(uid)); } catch (_) {}
    }
    onValue(userNotificationsRef(uid), snapshot => {
      const data = snapshot.val(); 
      if (data) {
        const arr = Object.keys(data).map(i => {
          data[i].id = i;
          return data[i];
        });
        arr.sort((a, b) => Number(b.dated || b.createdAt || 0) - Number(a.dated || a.createdAt || 0));
        dispatch({
          type: FETCH_NOTIFICATIONS_SUCCESS,
          payload: arr
        });
      } else {
        dispatch({
          type: FETCH_NOTIFICATIONS_SUCCESS,
          payload: []
        });
      }
    }, async (error) => {
      console.warn('[NOTIFICATIONS] onValue error (retrying via REST):', error?.message);
      const ok = await loadUserNotificationsViaRest(uid, dispatch);
      if (!ok) {
        dispatch({
          type: FETCH_NOTIFICATIONS_SUCCESS,
          payload: []
        });
      }
    });
  } catch (err) {
    console.warn('[NOTIFICATIONS] attach listener error:', err?.message);
    loadUserNotificationsViaRest(uid, dispatch);
  }
};

export const fetchNotifications = () => (dispatch) => {

  const {
    notifyRef
  } = firebase;

  dispatch({
    type: FETCH_NOTIFICATIONS,
    payload: null
  });
  onValue(notifyRef, snapshot => {
    if (snapshot.val()) {
      const data = snapshot.val();

      const arr = Object.keys(data).map(i => {
        data[i].id = i;
        return data[i];
      });

      arr.sort((a, b) => Number(b.dated || b.createdAt || 0) - Number(a.dated || a.createdAt || 0));

      dispatch({
        type: FETCH_NOTIFICATIONS_SUCCESS,
        payload: arr
      });
    } else {
      dispatch({
        type: FETCH_NOTIFICATIONS_SUCCESS,
        payload: []
      });
    }
  });
};

export const editNotifications = (notification, method) => (dispatch) => {
  const {
    notifyRef,
    notifyEditRef
  } = firebase;
  dispatch({
    type: EDIT_NOTIFICATIONS,
    payload: { method, notification }
  });
  if (method === 'Add') {
    push(notifyRef, notification);
  } else if (method === 'Delete') {
    remove(notifyEditRef(notification.id));
  } else {
    set(notifyEditRef(notification.id), notification);
  }
}

export const sendNotification = (notification) => async (dispatch) => {

  const {
    config,
    auth
  } = firebase;

  dispatch({
    type: SEND_NOTIFICATION,
    payload: notification
  });

  const origin = (typeof window !== 'undefined' && window.location) ? window.location.origin : null;
  const isLocalhost = origin && (origin.includes("localhost") || origin.includes("127.0.0.1"));
  const functionsUrl = (typeof process !== 'undefined' && process.env?.REACT_APP_FUNCTIONS_URL) ? process.env.REACT_APP_FUNCTIONS_URL.replace(/\/+$/, '') : null;
  let host = (!isLocalhost && origin) ? origin : (functionsUrl || "https://europe-west1-drive2go-c806b.cloudfunctions.net");
  let url = `${host}/send_notification`;

  let idToken = null;
  try {
    const { getValidAuthToken } = require("./authactions");
    idToken = await getValidAuthToken();
  } catch (_) {
    idToken = auth?.currentUser ? await auth.currentUser.getIdToken() : null;
  }
  const headers = { 'Content-Type': 'application/json' };
  if (idToken) headers['Authorization'] = `Bearer ${idToken}`;

  try {
    let res = await fetch(url, {
        method: 'POST',
        headers,
        body: JSON.stringify({
            "notification": notification
        })
    });
    if (!res.ok) {
      if (host !== "https://europe-west1-drive2go-c806b.cloudfunctions.net") {
        url = `https://europe-west1-drive2go-c806b.cloudfunctions.net/send_notification`;
        res = await fetch(url, {
          method: 'POST',
          headers,
          body: JSON.stringify({ "notification": notification })
        });
      }
      if (!res.ok) {
        const errText = await res.text();
        console.warn("[sendNotification] Response:", res.status, errText);
      }
    }
  } catch (err) {
    console.error("[sendNotification] Error:", err);
  }
}

export const deleteUserNotification = (notificationId) => async (dispatch, getState) => {
  if (!notificationId) return;

  const {
    auth,
    userNotificationsRef
  } = firebase;

  const state = typeof getState === 'function' ? getState() : (store ? store.getState() : {});
  const uid = auth?.currentUser?.uid || state?.auth?.profile?.uid || state?.auth?.info?.profile?.uid || state?.auth?.profile?.id || (typeof store !== 'undefined' && store?.getState()?.auth?.profile?.uid);

  // 1. Optimistic removal from Redux state immediately
  try {
    const current = state?.notificationdata?.notifications || [];
    const updated = current.filter(n => n.id !== notificationId && n.notifId !== notificationId);
    dispatch({
      type: FETCH_NOTIFICATIONS_SUCCESS,
      payload: updated
    });
  } catch (err) {
    console.warn('[NOTIFICATIONS] Redux optimistic remove error:', err?.message);
  }

  if (!uid) {
    console.warn('[NOTIFICATIONS] Cannot delete notification: uid is missing');
    return;
  }

  // 2. Remove via Firebase Realtime Database SDK
  try {
    const { ref: dbRef, remove: dbRemove } = require('firebase/database');
    const currentDb = firebase.database || (firebase.db);
    if (currentDb) {
      await dbRemove(dbRef(currentDb, `userNotifications/${uid}/${notificationId}`));
    }
  } catch (e) {
    console.warn('[NOTIFICATIONS] SDK remove error:', e?.message);
  }

  // 3. Fallback: Remove via direct REST API with authentication token
  try {
    const { getValidAuthToken } = require("./authactions");
    let token = await getValidAuthToken();
    const baseUrl = (firebase.config?.databaseURL || "https://drive2go-c806b-default-rtdb.europe-west1.firebasedatabase.app").replace(/\/$/, '');
    let rtdbUrl = `${baseUrl}/userNotifications/${uid}/${notificationId}.json${token ? `?auth=${token}` : ''}`;
    let res = await fetch(rtdbUrl, { method: 'DELETE' });
    if (res.status === 401) {
      token = await getValidAuthToken(true);
      if (token) {
        rtdbUrl = `${baseUrl}/userNotifications/${uid}/${notificationId}.json?auth=${token}`;
        await fetch(rtdbUrl, { method: 'DELETE' });
      }
    }
  } catch (e) {
    console.warn('[NOTIFICATIONS] REST delete error:', e?.message);
  }
};

